//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='component-wrapper'>
    <div>&nbsp;</div>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      news: null,
      filteredNews: []
    }
  },
  computed: {
    ...mapGetters([
      'commonData'
    ]),

    filteredData () {
      var filtered = []

      for (var key in this.news) {
        if ((this.news[key].publish === true) && (this.news[key].topical === true)) filtered.push(this.news[key])
      }

      /*
      arrayTools.sort(filtered, function (a, b) {
        if (a.val.dateReal === b.val.dateReal) return a.val.id < b.val.id
        return a.val.dateReal < b.val.dateReal
      })
      */

      this.filteredNews = filtered

      return filtered
    }
  },
  /* watch: {
    // сработает только если этот watch установлен раньше чем загрузятся данные (isLoaded еще false) - такое только при загрузке приложения.
    // в остальных случаях работаем через created
    'commonData.isLoaded': function (newVal, oldVal) {
      if (newVal === true) {
        this.news = this.commonData.news
      } else {
        this.news = null
      }
    }
  }, */
  created: function () {
    // if (this.commonData.isLoaded === true) { // это случай когда панель открывается позже чем создается приложении и watch выше уже не сработает никогда
    //   this.news = this.commonData.news
    // }
  },
  methods: {
    getShortBody (body) {
      if (body.length > 400) return body.substr(0, 400) + '...<br><br><a href="/news">Читать далее</a>'
      else return body.substr(0, 400)
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.component-wrapper{
  margin: 0px 0px 0px 0px;
  padding: 0px;
  /*border-radius: 4px;
  background: #f3f3fa;*/
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.one-news{
  margin: 0px 0px 20px 0px;
  padding: 20px;
  border-radius: 4px;
  background: #f3f3fa;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// CMSInfoPanelWidget.vue?4644a056